export const BrandMark = ({ size = 40, className = "", testId = "brand-mark" }) => (
  <svg
    data-testid={testId}
    width={size}
    height={size}
    viewBox="0 0 64 64"
    className={className}
    role="img"
    aria-label="J logo"
  >
    <defs>
      <linearGradient id="bmSky" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="64" y2="64">
        <stop offset="0%" stopColor="#CDEEFF" />
        <stop offset="55%" stopColor="#8CCFF2" />
        <stop offset="100%" stopColor="#5AAFE0" />
      </linearGradient>
      <linearGradient id="bmGold" gradientUnits="userSpaceOnUse" x1="18" y1="10" x2="46" y2="56">
        <stop offset="0%" stopColor="#FFF1BF" />
        <stop offset="35%" stopColor="#F4C95D" />
        <stop offset="75%" stopColor="#D49A1E" />
        <stop offset="100%" stopColor="#A8740F" />
      </linearGradient>
      <filter id="bmGlow" x="-30%" y="-30%" width="160%" height="160%">
        <feDropShadow dx="0" dy="1.5" stdDeviation="1.6" floodColor="#1E4E73" floodOpacity="0.45" />
      </filter>
    </defs>
    <rect width="64" height="64" rx="18" fill="url(#bmSky)" />
    <rect x="3" y="3" width="58" height="58" rx="15" fill="none" stroke="#FFFFFF" strokeOpacity="0.55" strokeWidth="1.2" />
    <path d="M6 40 Q 22 30 34 38 T 60 32" fill="none" stroke="#FFFFFF" strokeOpacity="0.35" strokeWidth="1.4" strokeDasharray="2 3" />
    <g transform="skewX(-10) translate(9 0)" filter="url(#bmGlow)">
      <path
        d="M38 15v22c0 8-5.5 13-12.5 13S14 45.5 13.5 39"
        fill="none"
        stroke="url(#bmGold)"
        strokeWidth="8.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M28 15h18" stroke="url(#bmGold)" strokeWidth="8.5" strokeLinecap="round" />
      <path d="M35.5 18.5v18" stroke="#FFF6D6" strokeOpacity="0.7" strokeWidth="1.6" strokeLinecap="round" />
    </g>
    <path d="M50 8l1.6 3.8L55.4 13l-3.8 1.6L50 18.4l-1.6-3.8L44.6 13l3.8-1.2z" fill="#FFF1BF" />
  </svg>
);
